import Vue from 'vue';
import { ProjectRPCSession } from '#/services/session';
import { FreshEntityGetRequest } from '#/services/entities/requests';
import { queryProjectClient } from '#/clients';

// eslint-disable-next-line import/prefer-default-export
export class EntityGetSession extends ProjectRPCSession {
  constructor(entityIds) {
    super();
    // this.entityId = FreshEntityId(entitySize, entityHash);
    this.entityIds = [];
    if (entityIds && entityIds.length > 0) {
      this.entityIds.push(...entityIds);
    }

    this.request = FreshEntityGetRequest(this.entityIds);
    this.entity = undefined;

    this.loading = false; // a request is open over the wire
  }

  async load() {
    if (this.loading) {
      return false;
    }
    this.loading = true;
    console.info('loading entity', this.entityIds);

    // TODO: abstract the header try/catch handling in in parent class
    const headers = await this.headers();
    return new Promise((resolve, reject) => {
      queryProjectClient.getEntities(this.request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from getEntities ', err);
          this.error = err;
          return reject(err);
        }
        console.log('received entity: ', response.toObject());
        const list = response.getEntitiesList();
        if (list.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          const entity = list[0];
          if (entity) {
            Vue.set(this, 'entity', entity);
          }
          // this.entity = list[0];
        }

        return resolve(response);
        // TODO: commit mutations on store to set jobs
        // TODO: remove list from dispatch in jobs. - relegate to this session
        // return resolve(response.toObject());
      });
    }).finally(() => {
      this.loading = false;
    });
  }

  // catch(error) {
  //   console.log('caught error loading job page:', error);
  //   this.error = error;
  //   return Promise.reject(error);
  // }
}
